import * as type from './types'


export function createSegmap(segmap) {
    return {
        type : type.CREATE_SEGMAP,
        payload : segmap,
        txn : 'initiated',
    };
}


export function savedSegmap(segmap, status = 'success', msg = 'Saved successfully.') {
    return {
        type : type.SAVED_SEGMAP,
        payload : segmap,
        txn : status,
        msg,
        diff : true
    };
}


export function editSegmap(segmap) {
    return {
        type : type.EDIT_SEGMAP,
        payload : segmap,
        txn : 'initiated',
    };
}


export function fetchSegmap() {
    return {
        type : type.FETCH_SEGMAP,
    };
}


export function fetchedSegmap(segmap) {
    return {
        type : type.FETCHED_SEGMAP,
        payload : segmap
    };
}


export function searchSegmap(segmap) {
    return {
        type : type.SEARCH_SEGMAP,
        payload : segmap
    };
}


export function storeSearchSegmapResult(segmap) {
    return {
        type : type.STORE_SEARCH_SEGMAP_RESULT,
        payload : segmap
    };
}


export function deleteSegmap(segmap) {
    return {
        type : type.DELETE_SEGMAP,
        payload: segmap
    };
}


export function deletedSegmap(msg) {
    return {
        type : type.DELETED_SEGMAP,
        payload : msg
    };
}


export function setNotifyDone(props) {
    return {
        type : type.NOTIFICATION_DONE_SEGMAP,
        payload: props
    };
}

export function filterItems(options) {
    return {
        type : type.FILTER_ITEMS,
        payload: options
    };
}

export function getCompanyDetails() {
    return {
        type : type.GET_COMPANY_DETAILS,
    };
}


export function savedCompanyDetails(segmap) {
    return {
        type : type.SAVED_COMPANY_DETAILS,
        payload : segmap,
        txn : 'success',
        diff : true
    };
}